export const industryData = [
    "aerospace",
    "artificial intelligence",
    "arts",
    "blockchain",
    "CRM",
    "customer service",
    "design",
    "fintech",
    "finance",
    "food",
    "hair",
    "HR",
    "makeup",
    "marketing",
    "operations",
    "other",
    "psychology",
    "radio",
    "sales",
    "skincare",
    "software",
    "research",
    "UX research",
    "venture capital",
];

export const revenueTabList = [
    {   
        id: "Stats",
        component: "RevenueStats",
        route: "revenue/stats",
        iconName: "report",
    },
    {   
        id: "Goals",
        component: "RevenueGoals",
        route: "revenue/goals",
        iconName: "workspace",
    },
    {   
        id: "History",
        component: "RevenueHistory",
        route: "revenue/history",
        iconName: "time",
    },
];

export const integrationTabList = [
    {   
        id: "Active integrations",
        component: "ActiveIntegrations",
        route: "settings/integrations/active",
        name: "integrations-active",
    },
    {   
        id: "Integration directory",
        component: "AllIntegrations",
        route: "settings/integrations/directory",
        name: "integrations-directory",
    },
];

export const scheduleTabList = [
    {   
        id: "Calendar",
        component: "Calendar",
        route: "schedule/calendar",
    },
    {   
        id: "Meetings",
        component: "Meetings",
        route: "schedule/meetings",
    },
];

export const clientTabList = [
    {   
        name: "Notes",
        component: "ClientNotes",
        iconName: "notes",
        iconFill: "sm",
    },
    {   
        name: "Projects",
        component: "ClientProjects",
        iconName: "project",
        iconFill: "sm",
    },
    {   
        name: "Invoices",
        component: "ClientInvoices",
        iconName: "receipt",
        iconFill: "sm",
    },
    {   
        name: "Meetings",
        component: "Meetings",
        iconName: "timer-solid",
        iconFill: "sm",
    },
    {   
        name: "Documents",
        component: "ClientDocuents",
        iconName: "folder-open",
        iconFill: "sm",
    },
    // {   
    //     name: "Check-ins",
    //     component: "ClientCheckIns",
    //     iconName: "at",
    //     iconFill: "sm",
    // },
];

export const projectTabList = [
    {   
        name: "Activity",
        component: "ProjectActivity",
    },
    {   
        name: "Notes",
        component: "ProjectNotes",
    },
    {   
        name: "Invoices",
        component: "ProjectInvoices",
    },
];

export const securityAccessQuestions = [
    "What is the name of your first pet?",
    "Who was your childhood hero?",
    "What is your mother's maiden name?",
    "What is the title of your favourite movie?",
    "What is the name of the street you lived in as a kid?",
    "What is the name of the street you lived in as a kid?",
];

export const settingsRoutesList = [
    {   
        name: "account",
        iconName: "user",
        id: "account-settings",
    },
    {   
        name: "general",
        iconName: "home",
        id: "general-settings",
    },
    // {   
    //     name: "calendars",
    //     iconName: "calendar",
    // },
    {   
        name: "notifications",
        iconName: "bell",
        id: "notifications-settings",
    },
    {   
        name: "pricing & plans",
        iconName: "store-alt",
        id: "plans-settings",
    },
    {   
        name: "payments & billings",
        iconName: "purchase-tag",
        id: "payment-settings",
    },
    {   
        name: "payment accounts",
        iconName: "bank",
        id: "payment-account-settings",
    },
    {   
        name: "integrations",
        iconName: "expand",
        id: "integrations-settings",
    },
    {   
        name: "goals & productivity",
        iconName: "map-pin",
        id: "goals-settings",
    },
];

export const faqs = [
    {
        question: "What does Ziner do?",
        answer: "We bundle multiple tools into a dynamic tool-kit to help individual freelancers with a more streamlined workflow. We offer an active database to track leads, manage projects, invoices, tasks, send out rate cards and even publish a publicly accessible profile.",
    },
    {
        question: "Who is Ziner for?",
        answer: "Ziner is built for creative professionals looking for a simple but robust platform tailored to their work needs",
    },
    {
        question: "How is Ziner different from other project management tools?",
        answer: "Unlike other tools out there, we simplify your workflows by allowing you to connect essential tools, manage integrations, clients/potential leads, projects, invoices...etc, to suit your needs as a freelancer, so you don’t have to juggle multiple apps.",
    },
    {
        question: "Can I use Ziner to manage multiple clients at once?",
        answer: "Absolutely. Ziner is designed to help you organise leads, ongoing projects, and past work — no matter how many clients you’re working with.",
    },
    {
        question: "Does Ziner handle payments?",
        answer: " Yes, you can send invoices directly to your clients, or through your existing payment links.",
    },
    {
        question: "Can I share my work publicly with Ziner?",
        answer: "Yes, you can publish a professional, publicly accessible profile that showcases what you do, making it easy for potential clients to reach out.",
    },
    {
        question: "Can I connect Ziner with other tools I already use?",
        answer: "Yes, we already integrate with popular tools for calendar management, lead capture, and productivity--so you can work in one connected space.",
    },
    {
        question: "What does Ziner cost?",
        answer: "We offer flexible plans, including a free plan, so you can find the option that fits your budget and workflow.",
    },
];

export const rankingList = [
    { 
        name: "Shoshinsha", 
        symbol: "初心者",
        desc: "Congratulations! You've completed up to 5 projects.", 
    },
    { 
        name: "Chūkyū", 
        symbol: "中級",
        desc: "Congratulations! You've completed up to 30 projects.", 
    },
    { 
        name: "Sensei", 
        symbol: "先生",
        desc: "Congratulations! You've completed up to 70 projects.", 
    },
    { 
        name: "Shishou", 
        symbol: "師匠",
        desc: "Congratulations! You've completed up to 160 projects.", 
    },
];

export const rankObj = {
    "Shoshinsha": "Congratulations! You've completed a minimum of 5 projects.", 
    "Chūkyū": "Congratulations! You've completed a minimum of 20 projects.", 
    "Sensei": "Congratulations! You've completed a minimum of 70 projects.", 
    "Shishou": "Congratulations! You've completed a minimum of 150 projects.", 
};

export const clientHeaders = [
    { id: "Name", accessorKey: "name", iconName: "user"},
    { id: "email", accessorKey: "email", iconName: "envelope-solid"},
    { id: "industry", accessorKey: "industry", iconName: "buildings"},
    { id: "status", accessorKey: "status", iconName: "reports-solid"},
    { id: "Date added", accessorKey: "createdAt", iconName: "timer-solid"},
];

export const projectHeaders = [
    { id: "Project title", accessorKey: "title", iconName: "user"},
    { id: "status", accessorKey: "status", iconName: "envelope-solid"},
    { id: "deadline", accessorKey: "deadline", iconName: "buildings"},
    { id: "Payment Status", accessorKey: "paymentStatus", iconName: "reports-solid"},
    { id: "Priority", accessorKey: "priority", iconName: "buildings"},
    { id: "Date added", accessorKey: "createdAt", iconName: "timer-solid"},
];

export const invoiceHeaders = [
    { id: "Client", accessorKey: "clientName", iconName: "envelope-solid"},
    { id: "Email", accessorKey: "clientEmail", iconName: "envelope-solid"},
    { id: "Status", accessorKey: "Status", iconName: "user"},
    { id: "Amount", accessorKey: "amount", iconName: "buildings"},
    { id: "Invoice No.", accessorKey: "invoiceNo", iconName: "reports-solid"},
    { id: "Due Date", accessorKey: "dueDate", iconName: "timer-solid"},
    { id: "Date added", accessorKey: "createdAt", iconName: "timer-solid"},
];

export const clientInvoiceHeaders = [
    { id: "Status", accessorKey: "Status", iconName: "user"},
    { id: "Amount", accessorKey: "amount", iconName: "buildings"},
    { id: "Invoice No.", accessorKey: "invoiceNo", iconName: "reports-solid"},
    { id: "Due Date", accessorKey: "dueDate", iconName: "timer-solid"},
    { id: "Date added", accessorKey: "createdAt", iconName: "timer-solid"},
];

export const paymentHistoryHeaders = [
    { id: "Billing Date", accessorKey: "paymentMethod", iconName: "envelope-solid"},
    { id: "Plan", accessorKey: "price", iconName: "user"},
    { id: "Amount", accessorKey: "duration", iconName: "buildings"},
    { id: "Status", accessorKey: "billingDate", iconName: "reports-solid"},
];

export const integrationHeaders = [
    { id: "Service name", accessorKey: "name", iconName: "user"},
    { id: "status", accessorKey: "status", iconName: "reports-solid"},
];

export const timeSheetHeaders = [
    { id: "Start date", accessorKey: "startDate", iconName: "user"},
    { id: "End date", accessorKey: "endDate", iconName: "timer-solid"},
    { id: "Total time", accessorKey: "totalTime", iconName: "buildings"},
];

export const trackerHeaders = [
    { id: "Start date", accessorKey: "startDate", iconName: "user"},
    { id: "Created At", accessorKey: "createdAt", iconName: "timer-solid"},
];

export const workingDays = [
    { name: "Sunday", isActive: false },
    { name: "Monday", isActive: true },
    { name: "Tuesday", isActive: false },
    { name: "Wednesday", isActive: true },
    { name: "Thursday", isActive: true },
    { name: "Friday", isActive: true },
    { name: "Saturday", isActive: false },
];

export const allowedCurrencies = ["USD", "NGN", "GBP", "GHS", "EUR"];

export const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

export const dateFormats = ["DD/MM/YY", "DD/MM/YYYY", "DD/MMMM/YYYY", "MM/DD/YY", "MMMM/DDDD/YYYY"];

export const daysOfWeek = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];

export const theme = ["default", "dark", "orange", "brick red"];

export const reminderEnum = [
    { id: "30_days_before", name: "30 days before"},
    { id: "21_days_before", name: "21 days before"},
    { id: "14_days_before", name: "14 days before"},
    { id: "7_days_before", name: "7 days before"},
    { id: "3_days_before", name: "3 days before"},
    { id: "1_day_before", name: "A day before"},
    { id: "on_due_date", name: "On"},
    { id: "1_day_after", name: "A day after"},
    { id: "3_days_after", name: "3 days after"},
    { id: "7_days_after", name: "7 days after"},
    { id: "14_days_after", name: "14 days after"},
    { id: "21_days_after", name: "21 days after"},
    { id: "30_days_after", name: "30 days after"},
    { id: "60_days_after", name: "60 days after"},
    { id: "90_days_after", name: "90 days after"},
];

export const mapReminders = {
    "30_days_before": "30 days before",
    "21_days_before": "21 days before",
    "14_days_before": "14 days before",
    "7_days_before": "7 days before",
    "1_day_before": "A day before",
    "on_due_date": "On due date",
    "1_day_after": "A day after",
    "3_days_after": "3 days after",
    "7_days_after": "7 days after",
    "14_days_after": "14 days after",
    "21_days_after": "21 days after",
    "30_days_after": "30 days after",
    "60_days_after": "60 days after",
    "90_days_after": "90 days after",
};

export const rateCardUploadHeaders = [
    { title: "Title", required: true },
    { title: "Currency", required: true },
    { title: "Amount", required: true },
    { title: "Rate Type", required: true },
    { title: "Description", required: false },
    { title: "Billable Hours", required: false },
    { title: "Billable Rate", required: false },
];

export const clientUploadHeaders = [
    { title: "Client Name", required: true, show: true, id: "name" },
    { title: "Email", required: true, show: true, id: "email" },
    { title: "Industry", required: false, show: true, id: "industry" },
    { title: "Status", required: false, show: true, id: "status" },
    { title: "Phone Number", required: false, show: true, id: "phoneNumber" },
    { title: "CC Emails", required: false, show: true, id: "ccEmails" },
    { title: "Country", required: false, show: true, id: "country" },
    { title: "City", required: false, show: true, id: "city" },
    { title: "State", required: false, show: true, id: "state" },
    { title: "Postal code", required: false, show: true, id: "zipCode" },
    { title: "Address", required: false, show: true, id: "address" },
];

export const projectUploadHeaders = [
    { title: "Title", required: true },
    { title: "Status", required: false },
    { title: "Payment status", required: false },
];

export const accountIntegrations = {
    calendar: [],
    time_tracking: [], // monday.com, google sheets
    email: [],
};

export const passwordChecks = {
    id: "sixCharacters",
};

export const projectInvoiceHeaders = [
    { id: "Invoice No.", accessorKey: "invoiceNo", iconName: "reports-solid"},
    { id: "Amount", accessorKey: "amount", iconName: "buildings"},
    { id: "Status", accessorKey: "Status", iconName: "user"},
    { id: "Date added", accessorKey: "createdAt", iconName: "timer-solid"},
];

export const billingMethods = [
    { id: "personal_account", name: "Manual payment via bank account", plans: ["free", "standard", "plus"] },
    { id: "payment_link", name: "Use a payment link", plans: ["free", "standard", "plus"] },
    { id: "automatic", name: "Automatic settlement", plans: ["plus"] },
];

export const days = ["Monday", "Tuesday", "Wednesday", "Thursday", "Fridays", "Saturday", "Sunday"];

export const tasksGroup = ["none", "tags", "priority"];

export const paymentProviders = [
    { id: "flutterwave", name: "Flutterwave" },
    { id: "paystack", name: "Paystack" },
];

export const taxTypes = [
    { id: "income", name: "Income" },
    { id: "vat", name: "Value Added Tax (VAT)" },
    { id: "payroll", name: "Payroll" },
    { id: "corporate", name: "Corporate" },
    { id: "sales", name: "Sales" },
    { id: "property", name: "Property" },
    { id: "tariff", name: "Tariff" },
    { id: "estate", name: "Estate" },
];

export const mapTaxTypes = {
    "income": "Income",
    "vat": "Value Added Tax (VAT)",
    "payroll": "Payroll",
    "corporate": "Corporate",
    "sales": "Sales",
    "property": "Property",
    "tariff": "Tariff",
    "estate": "Estate",
};

export const occupationList = [
    "software developer", "marketer", "digital content creator", "writing", "product designer", 
    "photographer", "videographer", "product manager", "project manager", "fashion designer",
    "business analyst", "data analyst", "data scientist", "finance analyst", 
    "researcher","personal assistant", "customer service personnel", "social media manager",
];

export const zinerUseCases = [
    "Track projects, tasks, and deadlines",
    "Manage invoices and payments",
    "Manage rate cards",
    "Manage leads and potential clients",
    "Schedule meetings",
    "Track revenue and growth, forecast earnings...etc",
    "All of the above",
];

export const pricingInfoData = [
    {
        "plan": "free",
        "description": "Ideal for your basic management needs.",
        "allowedFeatures": [
            "Client Database",
            "Project & Task Management",
            "Meeting Scheduling & Management",
            "Up to 3 invoices",
        ],
    },
    {
        "plan": "standard",
        "description": "Enhanced features as you scale.",
        "allowedFeatures": [
            "Client Database",
            "Project & Task Management",
            "Meeting Scheduling & Management",
            "Up to 1000 invoices",
            "Revenue Tracking & Reports",
            "App Integrations",
            "Custom Reminders",
            "Customizable Public Profile",
        ],
    },
    {
        "plan": "plus",
        // "description": "Comprehensive suite with advanced automation and integrations.",
        "description": "A more comprehensive suite of features.",
        "allowedFeatures": [
            "Client Database",
            "Project & Task Management",
            "Meeting Scheduling & Management",
            "Unlimited Invoicing",
            "Revenue Tracking & Reports",
            "App Integrations",
            "Custom Reminders",
            "Customizable Public Profile",
            "Time Tracking for projects",
            "Advanced Reporting",
            "Document Uploads",
            "Rate Cards",
        ],
    },
];

export const socials = ["Instagram", "X", "Pinterest", "Github", "Facebook", "TikTok", "LinkedIn"];

export const rateTypes = ["per-project", "hourly", "daily", "weekly", "monthly", "yearly", "one-off"];

export const rateCardSocialHeaders = [
    { id: "Platform name", accessorKey: "platformName", iconName: "reports-solid"},
    { id: "Link", accessorKey: "amount", link: "buildings"},
];

export const rateCardServiceHeaders = [
    { id: "Service Name", accessorKey: "serviceName", iconName: "reports-solid"},
    { id: "Rate Type", accessorKey: "description", iconName: "user"},
    { id: "Amount", accessorKey: "amount", iconName: "money"},
    { id: "Price Type", accessorKey: "priceType", iconName: "money"},
];

export const timeSelection = [
    "12:00", "12:15", "12:30", "12:45", "1:00", "1:15", "1:30", "1:45", "2:00", "2:15", "2:30", "2:45", 
    "3:00", "3:15", "3:30", "3:45", "4:00", "4:15", "4:30", "4:45", "5:00", "5:15", "5:30", "5:45", 
    "6:00", "6:15", "6:30", "6:45", "7:00", "7:15", "7:30", "7:45", "8:00", "8:15", "8:30", "8:45", 
    "9:00", "9:15", "9:30", "9:45", "10:00", "10:15", "10:30", "10:45", "11:00", "11:15", "11:30", "11:45", 
];

export const timeRepeatSchedule = {
    "Does not repeat": "",
    "Every day": "RRULE:FREQ=DAILY",
    "Every week": "RRULE:FREQ=WEEKLY",
    "Every month": "RRULE:FREQ=MONTHLY",
    "Every year": "RRULE:FREQ=YEARLY",
    "Weekday (Mon-Fri)": "RRULE:FREQ=WEEKLY;BYDAY=MO,TU,WE,TH,FR",
    "Custom": "",
};

export const completedProjectMarkers = [5, 20, 70, 150];

export const cardTypesBin = {
    4: "VISA",
    5: "MASTERCARD",
    6: "DISCOVER",
    36: "diners-club",
    38: "diners-club",
    34: "americanexpress",
    37: "americanexpress",
};

export const reportPages = [
    "Clients", 
    "Projects", 
    "Invoices", 
    "Tasks", 
    "Project tasks", 
    "Client details", 
    "Client notes", 
    "Client projects", 
    "Client invoices", 
    "Client meetings", 
    "Project notes", 
    "Project invoices", 
    "Create invoice", 
    "Edit invoice",
    "Reports",
    "Revenue",
    "Meetings",
    "Rate cards",
    "Account settings",
    "General settings",
    "Plans settings",
    "Integrations settings",
    "Notifications settings",
    "Goals settings",
];

export const checkInFrequencies = [

];

export const checkInTypes = [
    {
        id: "call",
        name: "Intro call",
        content: true,
    },
    {
        id: "service_provision",
        name: "Service provision",
        content: true,
    },
    {
        id: "meeting",
        name: "Sales call",
        content: true,
    },
    {
        id: "call",
        name: "Cold email",
        content: true,
    },
    {
        id: "meeting",
        name: "In-person conversation",
        content: true,
    },
    {
        id: "email",
        name: "Previous email",
        content: true,
    },
    {
        id: "reminder",
        name: "Just a reminder",
        content: false,
    },
];

export const termsAndConditions = [
    {
        heading: "Acceptance of Terms",
        content: "By accessing or using our project management platform (“Service”), you agree to be bound by these Terms and Conditions (“Terms”). If you do not agree, please do not use the Service.",
    },
    {
        heading: "Eligibility",
        content: "You must be at least 18 years old or have the legal authority to enter into a binding agreement to use this Service.",
    },
    {
        heading: "Description of Service",
        content: "Our Service enables users to manage projects, track time, invoice clients, schedule meetings via Google Calendar, and collaborate effectively. Features may evolve over time.",
    },
    {
        heading: "Account Registration",
        content: "You are responsible for maintaining the confidentiality of your login credentials. You agree to notify us of any unauthorized use of your account.",
    },
    {
        heading: "Usage Restrictions",
        content: "You agree not to:",
        subList: [
            { id: "", text: "Use the platform for unlawful purposes." },
            { id: "", text: "Reverse-engineer or tamper with the app’s code." },
            { id: "", text: "Interfere with the operation of the platform or attempt unauthorized access." },
        ],
    },
    {
        heading: "Subscription and Payments",
        content: "If your account involves paid features, you agree to our billing terms. Failure to pay may result in restricted access or account suspension.",
    },
    {
        heading: "Intellectual Property",
        content: "All content, branding, and software are the intellectual property of Ziner. You may not copy or reuse any part without permission.",
    },
    {
        heading: "Termination",
        content: "We may suspend or terminate your access if you breach these terms or engage in any behavior deemed harmful to our platform or users.",
    },
    {
        heading: "Third-Party Services",
        content: "We integrate with third-party services such as Google Calendar. Your use of such services is subject to their respective terms and policies.",
    },
    {
        heading: "Limitation of Liability",
        content: "We provide the service \"as is\" and do not guarantee it will be error-free or continuously available. We are not liable for any damages or loss resulting from your use of the service.",
    },
    {
        heading: "Modifications",
        content: "We may modify these terms from time to time. Continued use of the service after updates indicates your acceptance of the changes.",
    },
    // {
    //     heading: "Governing Law",
    //     content: "These terms shall be governed by the laws of Nigeria.",
    // },
];

export const policies = [
    {
        heading: "Information We Collect",
        content: "",
        subList: [
            { id: "Personal Information:", text: "Name, email, and optionally company name." },
            { id: "Account Data:", text: "Login credentials, billing info" },
            { id: "App Usage:", text: "Projects, tasks, time entries, client data, etc." },
            { id: "Integrations:", text: "Calendar data (via Google API), if connected." },
            { id: "Device & Log Data:", text: "IP address, browser type, timestamps, crash logs" },
            { id: "Emails:", text: "We may collect and store communication metadata for notifications, invoicing, or updates." },
        ],
    },
    {
        heading: "How We Use Your Information",
        content: "",
        subList: [
            { id: "", text: "To provide and improve the Service." },
            { id: "", text: "To personalize your experience." },
            { id: "", text: "To send administrative or product-related emails." },
            { id: "", text: "To comply with legal obligations." },
            { id: "", text: "To process payments (via third-party gateways)." },
        ],
    },
    {
        heading: "Third-Party Services",
        content: "We use third-party services, with each third-party service maintains its own privacy practices.",
        subList: [
            { id: "Google Calendar Integration (OAuth2)", text: "Only with your explicit permission." },
            { id: "Email delivery", text: "(e.g. via SendGrid or similar)." },
            { id: "Payment processors", text: "for subscriptions or invoicing (e.g. Stripe)." },
        ],
    },
    {
        heading: "Data Retention",
        content: "We retain your data as long as your account is active or as needed to provide the Service. You may request data deletion at any time.",
    },
    {
        heading: "Data Security",
        content: "We implement security measures to protect your data, including HTTPS encryption, access controls, and regular audits.",
    },
    {
        heading: "Your Rights",
        content: "Depending on your jurisdiction, you may have the right to:",
        subList: [
            { id: "", text: "Access your data." },
            { id: "", text: "Request corrections." },
            { id: "", text: "Request deletion." },
            { id: "", text: "Object to processing." },
        ],
    },
    {
        heading: "Cookies",
        content: "We may use cookies and similar technologies to improve user experience and gather usage analytics. You can control cookie preferences via your browser settings.",
    },
    {
        heading: "Children’s Privacy",
        content: "Our Service is not intended for children under 13 (or applicable age in your region), and we do not knowingly collect personal data from them.",
    },
    {
        heading: "Changes to This Policy",
        content: "We may update this Privacy Policy periodically. You will be notified of major changes via email or in-app notifications.",
    },
    {
        heading: "Contact Us",
        content: "For questions or data-related requests, contact: [your support email]",
    },
];

export const sharePlatform = [
    { id: "linkedin", iconName: "linkedin", name: "LinkedIn" },
    { id: "x", iconName: "x", name: "X" },
];

export const DATE_FILTERS = [
    {
        id: "7_days",
        name: "7 days",
    },
    {
        id: "14_days",
        name: "14 days",
    },
    {
        id: "21_days",
        name: "21 days",
    },
    {
        id: "30_days",
        name: "30 days",
    },
    {
        id: "60_days",
        name: "60 days",
    },
    {
        id: "90_days",
        name: "90 days",
    },
    {
        id: "1_year",
        name: "1 year",
    },
    {
        id: "custom",
        name: "Custom",
    },
];

export const DATE_FILTERS_MAP = {
    "7_days": "7 days",
    "14_days": "14 days",
    "21_days": "21 days",
    "30_days": "30 days",
    "90_days": "90 days",
    "1_year": "1 year",
    "custom": "Custom",
};

export const featureToolsMap = {
    "ziner_user": {
        // title: "Centralized platform for managing your work",
        title: "Access to multiple tools in one place",
        sub: "Stop juggling multiple tools and endless manual data sync when you need to work. We provide a more streamlined workflow by bundling different parts of your work tools in a single platform.",
    },
    "linkedin_circle": {
        title: "Capture data for potential leads",
        sub: "Ziner helps yWhen you capture the contatct information of potential leads who come scouting on your website or a networking tool like LinkedIn, we take that captured data and create a new client record for you on your dashboard.",
        "list": [
            "Project estimates",
        ],
    },
    "folder-open": {
        title: "Project management",
        sub: "Create and manage multiple projects in one place, giving you a clear overview of tasks, timelines, and progress without switching between tools. Track projects, create estimates, add billing information, schedule starting time for projects and many more...",
    },
    "spreadsheet": {
        title: "Time tracking",
        sub: "Track time spent on projects to boost productivity, log hours, and keep billing accurate.",
    },
    "task": {
        title: "Task management",
        sub: "Create tasks for projects, set deadlines, tasks priorities, check off completed tasks, stay more organized and productive.",
    },
    "user-badge": {
        title: "Client management",
        sub: "Whether you have active clients, potential leads or currently onboarding new clients; we offer a way to manage your clients with ease by providing a client database. Send client reminders, invoices, follow-ups...etc",
    },
    "email_circle": {
        title: "Email reminders",
        sub: "Find more ways to stay connected to your client through occasional reminders. Send automated or pre-written email reminders whether as check-ins, proposals, or meetings.",
    },
    "file-doc": {
        title: "Media management (WIP)",
        sub: "Upload, organize, and access media files for a specific client, project, tasks..etc, in one place.",
    },
    "receipt": {
        title: "Rate card management",
        sub: "Set up and manage rate cards for projects or clients—standardize pricing, save time, and ensure consistency.",
    },
};

export const remindersImg = [
    { icon: "💸", text: "Invoice #1024 payment reminder — due tomorrow", desc: "We handle reminders to your clients.", iconName: "money" },
    { icon: "✅", text: "Project “Website Redesign” is due in 2 days", desc: "Auto-reminders set for 48h and 2h before.",  iconName: "task" },
    { icon: "📅", text: "Follow up with Sarah about Q3 proposal", desc: "We'll send a polite nudge via email.",  iconName: "meeting" },
    { icon: "📌", text: "You have 5 pending tasks today!", desc: "Daily summary at 9:00 AM.",  iconName: "task" },
];

export const heroDataByProduct = {
    "client-management": {
        title: "Helping you build a more resillient network", // you are as strong as your network
        desc: "Organize, track, and grow your client relationships. Get access to a centralized directory of client information and contact history.",
        "ctaText": "grow and manage their clients.",
    },
    "project-management": {
        title: "Stay organized from planning to delivery",
        desc: "Track project progress, manage tasks, automate recurring events, meet deadlines and client deliverables. Keeping up with numerous things while staying productive",
        "ctaText": "keep their projects more organized.",
    },
    "reports": {
        title: "Comprehensive insights to fuel growth.",
        desc: "Turn your data into decisions that enhance performance growth. View, analyze and export reports in minutes.",
        cta: "Get advanced reporting",
        "ctaText": "get data insights for better decision making.",
    },
    "workflows": {
        title: "Boost your workflows",
        desc: "Avoid tool overload and disorganization. Improve your efficiency and automate key processes.",
        "ctaText": "enhance their workflows and stay productive.",
    },
    "finance": {
        title: "Manage and track your revenue",
        desc: "Create professional invoices, track payments, and understand your revenue performance. ",
        "ctaText": "manage and track their revenue.",
    },
    "reminders": {
        title: "Leave your reminders with us",
        desc: "Keep upcoming project and task deadlines top of mind, even while you’re managing multiple responsibilities",
        cta: "Start reminders",
        "ctaText": "customize and automate reminders. ",
    },
    "integrations": {
        title: "Our Integrations",
        desc: "Connect to your favorite essential tools to stay more productive",
        "ctaText": "enhance productivity via integrations.",
    },
};